<template>
  <div class="container-principal" :class="componenteAtual">
    <div style="width: 100%">
      <component
        :is="componenteAtual"
        :dados="dados"
        @dados-etapa="handleDadosEtapa"
        @proxima-etapa="proximo"
        @etapa-anterior="anterior"
        @ir-para-etapa="irParaEtapa"
      />
    </div>
  </div>
</template>

<script>
import Etapa1 from './Etapa1.vue'
import Etapa2 from './Etapa2.vue'
import Etapa3 from './Etapa3.vue'
import Etapa4 from './Etapa4.vue'
import Etapa5 from './Etapa5.vue'
import Etapa6 from './Etapa6.vue'
import Etapa7 from './Etapa7.vue'
import Etapa8 from './Etapa8.vue'
import Etapa9 from './Etapa9.vue'
import Etapa10 from './Etapa10.vue'
import Etapa11 from './Etapa11.vue'

export default {
  metaInfo: {
    title: 'Cofinanciamento Simulação',
    titleTemplate: null,
  },
  components: {
    Etapa1,
    Etapa2,
    Etapa3,
    Etapa4,
    Etapa5,
    Etapa6,
    Etapa7,
    Etapa8,
    Etapa9,
    Etapa10,
    Etapa11,
  },
  data() {
    return {
      dados: {
        etapa1: null,
        etapa2: null,
        etapa3: null,
        etapa4: null,
        etapa5: null,
        etapa6: null,
        etapa7: null,
        etapa8: null,
        etapa9: null,
        etapa10: null,
        etapa11: null,
      },
      etapaAtual: 1,
      etapasVisiveis: [1, 2, 3, 4, 6, 8, 9, 11, 10],
    }
  },
  computed: {
    componenteAtual() {
      return 'Etapa' + this.etapaAtual
    },
  },
  methods: {
    handleDadosEtapa({ etapa, dados }) {
      this.dados[etapa] = dados
    },
    /**
     * Avança para a próxima etapa visível.
     *
     * @returns {void}
     */
    proximo() {
      const indexAtual = this.etapasVisiveis.indexOf(this.etapaAtual)

      if (indexAtual < this.etapasVisiveis.length - 1) {
        this.etapaAtual = this.etapasVisiveis[indexAtual + 1]
      }
    },

    /**
     * Volta para a etapa anterior visível.
     *
     * @returns {void}
     */
    anterior() {
      const indexAtual = this.etapasVisiveis.indexOf(this.etapaAtual)

      if (indexAtual > 0) {
        this.etapaAtual = this.etapasVisiveis[indexAtual - 1]
      }
    },

    /**
     * Vai diretamente para uma etapa específica.
     *
     * @param {number} etapa
     * @returns {void}
     */
    irParaEtapa(etapa) {
      if (this.etapasVisiveis.includes(etapa)) {
        this.etapaAtual = etapa
      }
    },
  },
}
</script>
<style scoped lang="scss" src="./styles.scss" />
